'use strict';

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

function getCurrentDiscount() { 
  return globalConfig.discount.code || getCookieValue('discount_code')
}

function setText(discount) {
  const code = discount.code;
  var text = '¡Has conseguido un cupón de descuento!';

  if(!!code?.length > 0) {
    text = `¡Tienes un descuento de <a href="/cart" style="color: white;"><strong>${code}</strong></a>!`
  }
  document.querySelector('.utility-bar span').innerHTML = text;
}

if(getCurrentDiscount()) {
  setText(globalConfig.discount)
  document.querySelector('.utility-bar').classList.add('discount')
}